import { render, staticRenderFns } from "./usdr-swap.vue?vue&type=template&id=5ae18460&scoped=true&"
import script from "./usdr-swap.vue?vue&type=script&lang=js&"
export * from "./usdr-swap.vue?vue&type=script&lang=js&"
import style0 from "./usdr-swap.vue?vue&type=style&index=0&id=5ae18460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae18460",
  null
  
)

export default component.exports